// What a brief did NOT look at, and which of its sources were empty.
//
// Present on every brief, in both scopes. An empty page has two very
// different causes — nothing is due, or nothing has ever been recorded
// — and they render identically unless the page says which. The
// per-source counts are what separate "12 checked, 0 listed" from "no
// records exist yet".
//
// This lived only on the firm-wide view at first, which meant the
// person most likely to be staring at an unexplained empty page, on
// their own landing page, was the one who could not find out why.

import React, { useState } from "react";
import { C } from "../constants.js";

export function CoveragePanel({ coverage }) {
  const [open, setOpen] = useState(false);
  if (!coverage) return null;

  const sources = coverage.sources || [];
  const included = coverage.included || [];
  const excluded = coverage.excluded || [];

  return React.createElement("div", { style: { marginTop: "28px" } },
    React.createElement("button", {
      onClick: () => setOpen((v) => !v),
      style: { border: "none", background: "transparent", padding: 0,
               fontSize: "12px", color: C.navy, cursor: "pointer",
               textDecoration: "underline" },
    }, open ? "Hide what this covers" : "What this brief does not cover"),

    open && React.createElement("div", {
      style: { marginTop: "12px", background: C.warmWhite,
               border: `1px solid ${C.warmGray}`, borderRadius: "10px",
               padding: "16px 18px", fontSize: "12.5px",
               color: C.textMuted, lineHeight: 1.65 },
    },
      React.createElement("div", {
        style: { fontWeight: 700, color: C.navy, marginBottom: "4px" },
      }, "Looked at"),
      React.createElement("ul", { style: { margin: "0 0 14px 18px", padding: 0 } },
        // Counts, not just names. A source holding no records at all is
        // the one case where an empty brief means nothing was checked
        // rather than nothing was found.
        ...(sources.length
          ? sources.map((s, i) => React.createElement("li", { key: i },
              s.label,
              React.createElement("span", { style: { color: C.textLight } },
                s.examined === 0
                  ? " — no records exist yet"
                  : ` — ${s.examined} checked, ${s.matched} listed`),
              s.examined === 0 && s.populated_by
                && React.createElement("div", {
                     style: { color: C.textLight, fontSize: "11.5px" },
                   }, `Starts with ${s.populated_by}.`),
            ))
          : included.map((t, i) => React.createElement("li", { key: i }, t))),
      ),

      React.createElement("div", {
        style: { fontWeight: 700, color: C.navy, marginBottom: "4px" },
      }, "Not looked at"),
      React.createElement("ul", { style: { margin: "0 0 10px 18px", padding: 0 } },
        ...excluded.map((t, i) => React.createElement("li", { key: i }, t)),
      ),

      React.createElement("div", { style: { fontStyle: "italic" } },
        "An item missing from this brief has not been cleared — it was "
        + "either outside the window or not one of the things listed above."),
    ),
  );
}
